import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Calendar, User } from 'lucide-react';
import { cn } from '@/lib/utils';

type AdminResponseProps = {
  response?: string | null;
  resolvedAt?: Date | string | null;
  className?: string;
};

export default function AdminResponse({ 
  response,
  resolvedAt,
  className 
}: AdminResponseProps) {

  const formatDate = (date: Date | string) => {
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Only show if there's an actual response
  if (!response) {
    return null;
  }

  return (
    <Card className={cn('border-l-4 border-l-blue-500 bg-blue-50/30', className)}>
      <CardContent className='p-4'>
        <div className='space-y-4'>
          {/* Header */}
          <div className='flex items-center justify-between'>
            <div className='flex items-center gap-3'>
              <Avatar className='h-8 w-8'>
                <AvatarFallback className='bg-blue-100 text-blue-700 text-xs'>
                  AD
                </AvatarFallback>
              </Avatar>
              <div>
                <div className='flex items-center gap-2'>
                  <User className='h-3 w-3 text-gray-500' />
                  <span className='text-sm font-medium text-gray-900'>
                    Admin
                  </span>
                  <Badge 
                    variant='outline' 
                    className='bg-blue-100 text-blue-700 border-blue-200 text-xs'
                  >
                    Support Team
                  </Badge>
                </div>
                <div className='flex items-center gap-1 text-xs text-gray-500'>
                  <Calendar className='h-3 w-3' />
                  <span>Resolved on {resolvedAt ? formatDate(resolvedAt) : 'Recently'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Response Content */}
          <div className='bg-white rounded-lg p-4 border border-blue-100'>
            <h4 className='font-medium text-gray-900 mb-2 text-sm'>Admin Response</h4>
            <p className='text-sm text-gray-700 leading-relaxed whitespace-pre-wrap'>
              {response}
            </p>
          </div>

          {/* Footer */}
          <div className='text-xs text-gray-500 text-center'>
            This inquiry has been resolved by our support team
          </div>
        </div>
      </CardContent>
    </Card>
  );
}